import React from 'react';
import { UIText3 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface ILabelComponentProps {
  text: string;
}

export const LabelComponent: React.FC<ILabelComponentProps> = ({ text }) => {
  return (
    <div className={styles['label']}>
      <UIText3 color={'text-primary-default'}>{text}</UIText3>
    </div>
  );
};

LabelComponent.displayName = 'LabelComponent';
